import angular from 'angular';

/**
 * Legacy module — preserved as empty so deps keep resolving.
 * Real implementation: apps/b2b-frontend/app/core/sidebar/sidebar.service.ts
 * Registered via downgradeInjectable in
 * apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 */
export { SidebarService } from '@ng/core/sidebar/sidebar.service';

export const SidebarServiceModule = angular.module('acme.common.service.sidebar', []).name;
